import React from "react";
import "./About_us.css";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import AboutSection from "../home/aboutSection/AboutSection";
import MenuSection from "./menuSection/MenuSection";

function About_us() {
  const aboutImages = [
    "/assets/images/gallery/img_5.webp",
    "/assets/images/gallery/img_8.webp",
  ];

  return (
    <>
      <section className="About_us_aboutSection">

        {/* ======= BANNER ======= */}
        <div className="aboutSection-banner">
          <h2>About Us</h2>
          <p><Link to={"/"}>Home</Link> / About Us</p>
        </div>

        <Container>
          <Row className="align-items-center aboutSection-row">

            {/* LEFT CONTENT */}
            <Col lg={6} className="aboutSection-left">
              <h3 className="aboutSection-title">About Jaltaara Resort</h3>

              <p className="aboutSection-text">
                Welcome to <strong>Jaltaara</strong>, a peaceful nature retreat located at 
                <strong> At Post Tetali, Tal. Jawali, Dist. Satara</strong>—popularly known
                as <strong>New Mahabaleshwar</strong>. Surrounded by misty valleys, lush forests,
                and fresh mountain air, our resort offers a perfect escape for those seeking 
                tranquility and comfort.
              </p>

              <p className="aboutSection-text">
                Jaltaara is thoughtfully designed to blend modern luxury with natural beauty.
                Whether you’re planning a weekend getaway, a romantic holiday, or a peaceful 
                family vacation, our warm hospitality ensures that every moment of your stay 
                becomes memorable.
              </p>

              <p className="aboutSection-text">
                From cozy accommodations to scenic outdoor spaces, we focus on delivering a 
                relaxing experience where you can disconnect from the noise and reconnect with nature.
              </p>

              <h4 className="aboutSection-subtitle mt-4">Why Choose Jaltaara?</h4>

              <p className="aboutSection-text">
                <strong>• Scenic Location:</strong> Experience breathtaking valley views, green 
                landscapes, and the refreshing climate of New Mahabaleshwar.
              </p>

              <p className="aboutSection-text">
                <strong>• Comfortable Rooms:</strong> Spacious, clean, peaceful rooms designed 
                for relaxation and comfort.
              </p>

              <p className="aboutSection-text">
                <strong>• Delicious Food:</strong> Enjoy fresh, homely meals prepared with care. 
                Our room service ensures your comfort is never disturbed.
              </p>

              <p className="aboutSection-text">
                <strong>• Peace & Serenity:</strong> The perfect destination for nature lovers, 
                offering calm surroundings and zero city disturbance.
              </p>

            </Col>

            {/* RIGHT IMAGES USING MAP */}
            <Col lg={6} className="aboutSection-right_section">
              <div className="aboutSection-imgWrapper">
                {aboutImages.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt="About"
                    className="aboutSection-img"
                  />
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>


   

      {/* HOMEPAGE ABOUT SECTION BELOW */}
      <AboutSection />
    </>
  );
}

export default About_us;
